import React from "react";
import { Link } from "react-router-dom";

function LegalDocs() {
  return (
    <section className="py-5">
      <div className="container" style={{ maxWidth: 720 }}>
        <div className="text-center mb-4">
          <h2 className="section-title">Legal Documents</h2>
          <p className="text-muted">Policies and agreements for Family Ring.</p>
        </div>
        <div className="feature-card">
          <ul className="list-unstyled mb-0">
            <li className="mb-2">
              <Link className="text-decoration-none" to="/legalDocs/TermsAndConditions">Terms and Conditions</Link>
            </li>
            <li className="mb-0">
              <Link className="text-decoration-none" to="/legalDocs/PrivacyPolicy">Privacy Policy</Link>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default LegalDocs;
